/**
 * @title application-form.js: Feature level module
 * @description Membership application form functionality
 */
define(['membershipHelper'], function(helper) {
  let AffiliateForm = {
    init: function() {
      // Moving this to application.js because we need to grab
      // configProduct first (which is async) and then display
      // this.reflectAffiliates();
    },
    /**
     * This is business membership form specific. If the user has 6
     * added affiliates, we don't allow any more.
     * @param {Object} data - OPTIONAL Passed by thenable. Used to chain
     * @return {Object} OPTIONAL - The data passed as an argument.
     *                           Meant for chaining
     */
    checkAffiliateNumber: function(data) {
      let affiliates = helper.getAffiliates();

      if (COSTCO.MembershipHelper.isQuickMembership) {
        if (affiliates.length == 0) {
          $('#add-a-person').removeClass('hide');
          $('#add-another-person').addClass('hide');
        } else if (affiliates.length > 0 && affiliates.length < 6) {
          $('#add-a-person').addClass('hide');
          $('#add-another-person').removeClass('hide');
        } else {
          $('#add-a-person').addClass('hide');
          $('#add-another-person').addClass('hide');
        }
      } else {
        affiliates.length >= 6 ?
          $('#add-person-button').addClass('hide') :
          $('#add-person-button').removeClass('hide');
      }

      return data;
    },
    /**
     * Uses the stored affiliate form (set by onclose events in editPerson
     * /addPerson) to populate the #affiliate-form (modal). This is used to
     * populate the affiliate form when the user escapes from a another modal
     * and comes back to the affiliate modal e.g. Address Verification.
     * @return {void}
     */
    populateUsingStoredForm: function() {
      // When the modal is 'shown' or 'open' we
      // try to populate the form with what the user last entered.
      let affForm = AffiliateForm;
      let storedForm = affForm.storedAffiliateForm;
      helper.formWizBangs(affForm.getForm());
      if (storedForm) {
        COSTCO.MembershipHelper.populateByName(affForm.getForm(),
          storedForm.serializeArray());
        if (storedForm.find('#affiliate-household').prop('checked')) {
          affForm.getForm().find('#affiliate-household').prop('checked', true);
          affForm.getForm().find('#affiliate-household').val(true);
          affForm.householdToggle();
        }
      }
      affForm.storedAffiliateForm = undefined;
    },
    /**
     * Validation rules for the affiliate form
     * @return {Boolean} Is the affiliate form valid?
     */
    validate: function() {
	  const dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	  helper.goldstar.rules.dobmonth.required = dayIsOptional;
	  helper.goldstar.rules.dobyear.required = dayIsOptional;
      let rules = helper.goldstar.rules;
      let messages = helper.goldstar.messages();
      let form = this.getForm().length > 0 ? this.getForm() : this.storedAffiliateForm;
      data = COSTCO.util.objectifyArray(form.serializeArray());
      data.householdCheckbox = data.householdCheckbox ? true : false;
      if(data.householdCheckbox){
          helper.addHouseholdRules(rules,true,messages);
      }
      rules.email.required = false;
      rules.emailConfirm.required = false;
      rules.emailConfirm.equalTo = '#affiliate-email';
      // Override validator messages
      $.extend($.validator.messages, messages);
      // Override $.validate.methods to accommodate affiliate context.
      helper.addValidationMethods(this.getForm());
      this.getForm().validate({
        invalidHandler: COSTCO.util.invalid_handler,
        rules: rules,
        messages: messages,
      });
      return this.getForm().valid();
    },
    /**
     * Gets the appropriate request data for whatever CRUD operation we're
     * performing.
     * @param  {Object} options The object that distinguishes what CRUD op we're
     *                          doing. Everything except 'add' action requires
     *                          an affiliate object be attached as a property.
     * @return {Object}         The request data to be passed to whichever cmd.
     */
    getRequestData: function(options) {
      let data = {};
      if (options.action == 'add' || options.action == 'update') {
        // This block takes addresses from the verification service and populates
        // the form with that information so we can just serialize this.
        let form = this.getForm().length > 0 ? this.getForm() : this.storedAffiliateForm;
        addresses = Array.isArray(options.addresses) // Test if we have valid addresses
          ?
          options.addresses // Using the addresses passed to "submit"
          :
          helper.buildAddressArray(form, {
            primary: helper.affiliateAddressSelectors,
          }); // using original addresse from user input
        helper.populateAddressData(form, addresses, true);
        // In both cases we have a form that needs to be serialized and sent.
        data = COSTCO.util.objectifyArray(form.serializeArray());
        data.householdCheckbox = data.householdCheckbox ? true : false;
        const dayIsOptional = $('#dobYearMonthMandatoryFlag').val()==='true';
        if(dayIsOptional) {
            //dobday is optional, if empty default it to "1"
            if (!data.dobday) {
            	data.dobday="1";
            }
            //householdDobDay is optional, if empty default it to "1"
            if (!data.householdDobDay) {
            	data.householdDobDay="1";
            }
        }
        // If the flow is from renew or business details adjust the url
        // approproiately. Uses /MemberAffiliateAddCmd.
        if (options.isRenew || options.isBusinessDetails || options.isOutsideRenewal /* placeholder for isDetails */ ) {
          options.addHousehold
            // Adding a household to an affiliate
            ?
            data.url = COSTCO.util.makeUrl('/MemberHouseholdAddCmd', {
              'primaryNumber': options.affiliate.cardNumber.value,
              'type': 'affiliate',
              'authToken': COSTCO.Checkout.getAuthToken(),
            })
            // Adding an affiliate to a business membership
            :
            data.url = '/MemberAffiliateAddCmd';
        } else { // Membership Application flow
          data.url = this.getUrl('/MemberApplicationAffiliateAddCmd');
        }
        data.isRenew = options.isRenew;
        data.isBusinessDetails = options.isBusinessDetails;
        data.isOutsideRenewal = options.isOutsideRenewal;
        data.addHousehold = options.addHousehold;
        this.storedAffiliateForm = undefined;
      } else if (options.action == 'remove-household') {
        if (options.isRenew || options.isBusinessDetails || options.isOutsideRenewal /* placeholder for isDetails */ ) {
          data.url = COSTCO.util.makeUrl('/MemberHouseholdRemoveCmd', {
            'primaryNumber': options.affiliate.membershipNumber,
            'householdNumber': options.affiliate.houseHold.membershipNumber,
            'type': 'affiliate',
            'authToken': COSTCO.Checkout.getAuthToken(),
          });
          data.isRenew = options.isRenew;
          data.isBusinessDetails = options.isBusinessDetails;
          data.isOutsideRenewal = options.isOutsideRenewal;
          data.excludeData = options.excludeData;
        } else { // Membership Application flow
          // We're removing a household from an affiliate.
          let affiliate = options.affiliate;
          let arr = helper.getSerializedAffiliateData(affiliate);
          data = COSTCO.util.objectifyArray(arr);
          data.url = this.getUrl('/MemberApplicationAffiliateAddCmd');
          data.householdCheckbox = false;
          // Backend is expecting action: update for this operation.
          options.action = 'update';
        }
      } else if (options.action == 'remove-affiliate') {
        // Removing a affiliate for the renew / business details flow.
        data.url = COSTCO.util.makeUrl('/MemberAffiliateRemoveCmd', {
          MembershipRenewUpgrade_removeAffiliate: options.affiliate.membershipNumber,
          MembershipRenewUpgrade_isQuickMembershipCheckout: options.isQuickMembershipCheckout,
        });
        data.isRenew = options.isRenew;
        data.isBusinessDetails = options.isBusinessDetails;
        data.isOutsideRenewal = options.isOutsideRenewal;
        data.excludeData = options.excludeData;
      } else { // Removing an affiliate for the membership application flows
        data.url = this.getUrl('/MemberApplicationAffiliateUpdateCmd');
        $.extend(data, options.affiliate);
      }
      // In the case where we're modifying affiliates, send the corresponding
      // membership numbers as part of the formdata.
      if (options.affiliate) {
        data.affiliateMembershipNumber = options.affiliate.affiliateMembershipNumber;
        if (options.affiliate.houseHold) {
          data.affiliateHouseholdMembershipNumber =
            options.affiliate.houseHold.membershipNumber;
        }
      }
      data.action = options.action;
      if (location.hostname == 'wcs.costco.com') { // Show me what you got.
        console.log(JSON.stringify(data, null, 2));
      }
      return data;
    },
    /**
     * Returns a URL corresponding to the command we want to call. Could be
     * /MemberApplicationAffiliate[Add|Update]Cmd. Requests to these commands
     * require the orderItemsId (xorderitems.orderItemsId) and organizationId
     * (business identifier) to be passed as query strings.
     * @param  {String} command The command we want to make a request to.
     * @return {String}         The url with appropriate querystrings.
     */
    getUrl: function(command) {
      let configProduct = helper.getConfigProduct();
      let urlParams = {
        orderItemsId: configProduct.applicationTrackingCookie,
        organizationId: configProduct.organizationId,
      };
      // ALM 52783: If the form is on Membership Application or Quick Membership Checkout page, send the information that it's
      // membership purchase flow (needed to correctly calculate membership total price after adding an affiliate)
      if ($('div#membership-application').data('page') == COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP
          || $('div#quick-membership-checkout').data('page') == COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE) {
        urlParams.fromPage = COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE;
      }
      return COSTCO.util.makeUrl(command, urlParams);
    },
    /**
     * This is the primary ajax wrapper for all crud operations related to
     * affiliates and their attached households.
     * @param  {Object} requestData The object containing all relevant request
     *                              data. Use this.getRequestData to get the
     *                              correct data to be passed.
     * @return {jQuery.Deferred}    Used to chain thenables.
     */
    submit: function(requestData) {
      $('.order-ajax').addClass('ajax-busy');
      let data;
      if ((requestData.isRenew || requestData.isBusinessDetails || requestData.isOutsideRenewal) && requestData.addHousehold /* isDetails placeholder */ ) {
        data = helper.transformAffiliateHouseholdInputNames(requestData);
      } else if (requestData.isRenew || requestData.isBusinessDetails || requestData.isOutsideRenewal /* isDetails placeholder */ ) {
        data = helper.transformAffiliateInputNames(requestData);
      } else {
        data = {
          formdata: encodeURIComponent(JSON.stringify(requestData)),
        };
      }
      return COSTCO.util.ajax({
        type: 'POST',
        url: requestData.url, // this.getUrl(),
        dataType: 'json',
        global: false,
        // If we don't need POST data, excludeData is set to true
        // and we just pass an empty object. The request probably has
        // the data it needs in the querystring.
        data: requestData.excludeData ? {} : data,
      });
    },
    /**
     * Returns a jQuery form object representing the Affiliate form (modal)
     * @return {jQuery} The jQuery object represetning the form.
     */
    getForm: function() {
      // TRAIL - TODO: Check if better name for this form is required
      return $('#affiliate-form');
    },
    /**
     * Inline event handler for the checkbox in the add person modal to
     * toggle hiding and showing the household form.
     * @return {void}
     */
    householdToggle: function() {
      $('#affiliate-household-container').toggleClass('hide');
    },
    /**
     * This function opens the "Add Person to Membership" modal.
     * @param  {Object} data This is not always passed. It is passed after
     *                       the POST to /MemberApplicationAddCmd returns. In
     *                       the case where we're on RenewMembershipView, we
     *                       associate the property isRenew as the contract
     *                       with the backend is slightly different.
     * @return {void}
     */
    openAddPersonModal: function(data) {
      $('.permanent-ajax-busy').removeClass('ajax-busy');
      if (data && data.error) {
        // Case where we first need to POST to /MemberApplicationAddCmd
        // before we invoke the add person modal and it returns an error.
        // We don't want to show the modal in this case, just display the error.
        return;
      }
      // 5.1 Use appropriate template for modal
      COSTCO.dialog.modalStack({
        title: messages.MEMBERAPPLICATION_AFFILIATE__modalAddAffiliateTitle,
        body: COSTCO.util.tmpl('tmpl_affiliate', {
          affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {}),
        }),
        secondary: messages.JS_DIALOG_CANCEL,
        primary: messages.MEMBERSHIP_AddPerson,
        primary_event: function() { // user selected "Add Person"
          // 5.3 Validate the form
          if (AffiliateForm.validate()) {
            let options = {
              action: 'add',
              isRenew: data && data.isRenew || false,
              isBusinessDetails: data && data.isBusinessDetails || false,
              isOutsideRenewal: data && data.isOutsideRenewal || false,
            };
            helper
              // Execute address verification on the affiliate address.
              .verifyAddresses({
                form: '#affiliate-form',
                primary: helper.affiliateAddressSelectors,
              })
              // Invoke the address verification modal
              .then((verifyResponse) => helper.invokeMultiAVS(verifyResponse,
                AffiliateForm.crudSequence.bind(options)))
              // If the service fails, still submit the form.
              .fail(AffiliateForm.crudSequence.bind(options));
          }
        },
        onclose: function() {
          // We'll temporary store this form so we can serialize it after its
          // been closed and we're looking at the address verification modal.
          // We can also use this to populate the form.
          AffiliateForm.storedAffiliateForm = AffiliateForm.getForm();
        },
        onshown: function() {
          AffiliateForm.populateUsingStoredForm();
        },
      });
      // A new call to open this modal shouldn't prepopulate with the result
      // of a previously stored form.
      this.storedAffiliateForm = undefined;
    },
    /**
     * This function handles removing an affiliate or an affiliate's attached
     * household. application.js has decorator functions that are inline event
     * handlers that end up calling this.
     * @param  {Object} options Options object that contains an affiliate object
     *                          property and a switch for removing either the
     *                          affiliate or the affiliate's household.
     * @return {void}
     */
    removePerson: function(options) {
      let action = options.action;
      options.isRenew /* isBusinessDetails */ = options && options.isRenew || false;
      options.isBusinessDetails /* isBusinessDetails */ = options && options.isBusinessDetails || false;
      options.isOutsideRenewal /* isBusinessDetails */ = options && options.isOutsideRenewal || false;
      options.excludeData /* isBusinessDetails */ = options && options.excludeData || false;
      COSTCO.dialog.showModal({
        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        body: COSTCO.util.tmpl(options.isOutsideRenewal ? 'tmpl_remove_affiliate_outside_renewal' : 'tmpl_remove_affiliate', {
          affiliate: action == 'remove-household'
            // Here we send the household object to the template
            // because we're removing the household.. just want to show
            // the household name.
            ?
            options.affiliate.houseHold : options.affiliate,
          newCreated: options.affiliate ? options.affiliate.newCreated : false,
        }),
        secondary: messages.JS_DIALOG_CANCEL,
        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        primary_event: () => { // user selected "Remove Person"
          this.crudSequence.call(options);
          COSTCO.dialog.close();
        },
      });
    },
    editPerson: function(options) {
      // See application.js.addPersonWithinHousehold for explanation here.
      let title = options.addHousehold ?
        COSTCO.util.capitalize(messages.ADDHOUSEHOLD_TITLE) :
        options.editHousehold ?
        messages.EDITHOUSEHOLD_TITLE :
        messages.MEMBERSHIP_EditPerson;
      COSTCO.dialog.modalStack({
        title: title,
        body: COSTCO.util.tmpl('tmpl_affiliate', {
          affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {}),
        }),
        secondary: messages.JS_DIALOG_CANCEL,
        primary: options.addHousehold ? messages.MEMBERSHIP_AddPerson : messages.UPDATE,
        primary_event: () => { // user selected "Edit Person"
          // 5.3 Validate the form
          if (this.validate()) {
            if (!options.editHousehold && !options.addHousehold) {
              // This tells onshown to use the newly editted form if the user
              // escapes and returns back to the affiliate form.
              options.useStored = true;
              helper
                // Execute address verification on the affiliate address.
                .verifyAddresses({
                  form: '#affiliate-form',
                  primary: helper.affiliateAddressSelectors,
                })
                // Invoke the address verification modal
                .then((verifyResponse) => helper.invokeMultiAVS(verifyResponse,
                  AffiliateForm.crudSequence.bind(options)))
                // If the service fails, still submit the form.
                .fail(AffiliateForm.crudSequence.bind(options));
            } else {
              // Household doesn't require verification.
              this.crudSequence.call(options);
              COSTCO.dialog.close();
            }
          }
        },
        onclose: function() {
          // We'll temporary store this form so we can serialize it after its
          // been closed and we're looking at the address verification modal.
          // We can also use this to populate the form.
          AffiliateForm.storedAffiliateForm = AffiliateForm.getForm();
        },
        onshown: function() {
          if (options.useStored) {
            // Here we use the stored affiliate form to repopulate the form
            // as the user escaped from address verification.
            affForm.populateUsingStoredForm();
          }
        },
      });
      let affForm = AffiliateForm;
      // Populate date of birth selects, etc.
      helper.formWizBangs(affForm.getForm());
      // Populate the form with information about the affiliate
      helper.populateElement(affForm.getForm(), options.affiliate);
      // Clear the household values as some of these inputs share the same
      // data-configproduct attribute. We'll populate them below if exist.
      $('#affiliate-household-container input').val('');
      $('#affiliate-household-container select').find('option:first').prop('selected', true);
      // If the affiliate has a household attached, show and populate
      if (options.affiliate.houseHold) {
        affForm.getForm().find('#affiliate-household').prop('checked', true);
        affForm.getForm().find('#affiliate-household').val(true);
        helper.populateElement(affForm.getForm().find('#affiliate-household-container'),
          options.affiliate.houseHold);
        affForm.householdToggle();
      }
      // This is the varition of the modal where we're actually just adding/editing
      // a household. We want to hide the affiliate container and show just the
      // household inputs.
      if (options.addHousehold || options.editHousehold) {
        $('.affiliate-container').addClass('hide');
        $('#affiliate-household-container').addClass('only-household');
        affForm.getForm().find('#affiliate-household').prop('checked', true);
        affForm.getForm().find('#affiliate-household').val(true);
      }
      if (options.addHousehold) {
        affForm.householdToggle();
      }
    },
    /**
     * This represents the sequence of actions for performing CRUD operations
     * related to affiliates. This should include several (a)sync functions
     * like address verification and data return handling functions.
     * @param  {Object} addresses The addresses returned from address verification
     * @return {void}
     */
    crudSequence: function(addresses) {
      $.extend(this, {
        addresses: addresses,
      });
      let requestData = AffiliateForm.getRequestData(this);
      if (requestData.isRenew /* isDetails placeholder */ ) {
        // In the case where we are in the renew or business details flow,
        // we want to reflect the newly added affiliates and change some other state.
        COSTCO.AffiliateForm.submit(requestData)
          // If we have errors, display them.
          .then((data) => {
            if ($('#quick-membership-checkout').length != 0) {
              window.location.reload(true);
            } else {
              data.retainNotification = true;
              return helper.handleErrors(data);
            }
          })
          // After a crud operation to affiliates, reflect them using the
          // JSON response from the server.
          .then(helper.reflectAffiliatesAlternate)
          // If we already have 6 newly added affiliates, we dont want to allow
          // any more for this transaction.
          .then(helper.canAddAffiliate)
          // Update the total price. If the user selected the link,
          // "upgrade to a business executive membership" (business membership
          // flow), RenewMembership.isUpgrading was set true, show the
          // renewAndUpgradeAmount
          .then((data) => {
            let isUpgrading = COSTCO.RenewMembership.isUpgrading || false;
            return helper.updateTotalPrice(data, isUpgrading);
          })
          // Switch the add person link if needed
          .then(helper.addPersonLink)
          // Kurt TODO: Does the add to cart link change?
          // If the command fails, handle them
          .fail(helper.handleErrors);
      } else if (requestData.isBusinessDetails) {
        COSTCO.AffiliateForm.submit(requestData)
          // If we have errors, display them.
          .then((data) => {
            if ($('#quick-membership-checkout').length != 0) {
              window.location.reload(true);
            } else {
              data.retainNotification = true;
              return helper.handleErrors(data);
            }
          })
          .then((data) => {
            let hasErrors = data && data.error && data.errorMessages.length > 0;
            if (!hasErrors) {
              return location.reload(true);
            } else {
              return;
            }
          }).fail(helper.handleErrors);
      } else if (requestData.isOutsideRenewal) {
        // In the case where we are in the business details flow,
        // adding additional people outside renewal period.
        COSTCO.AffiliateForm.submit(requestData)
          // If we have errors, display them.
          .then((data) => {
            if ($('#quick-membership-checkout').length != 0) {
              window.location.reload(true);
            } else {
              data.retainNotification = true;
              return helper.handleErrors(data);
            }
          })
          // After a crud operation to affiliates, reflect them using the
          // JSON response from the server.
          .then(helper.reflectAffiliatesBussinessOutsideRenewal)
          // If the command fails, handle them
          .fail(helper.handleErrors);
      } else {
        // This case represents the membership application flow where we want
        // to set the config product thats stored in local storage after
        // submitting the request.
        COSTCO.AffiliateForm.submit(requestData)
          // returns configProduct
          .then(helper.setConfigProduct)
          // If we have errors, display them.
          .then(helper.handleErrors)
          // When we're done, we want to show the affiliates
          .then(() => {
            if ($('#quick-membership-checkout').length != 0) {
              window.location.reload(true);
            } else {
              helper.reflectAffiliates();
            }
          })
          // If the command fails, handle them
          .fail(helper.handleErrors);
      }
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.AffiliateForm = AffiliateForm;
  return AffiliateForm;
});



// WEBPACK FOOTER //
// ./js/membership/application-affiliate-form.js